import React from 'react'
import uniqid from 'uniqid'

import IconSwitchUI from './IconSwitchUI'
import { getStaticImage } from 'utils/statics'

const IconSwitch = ({ iconType, height, isActive, tooltip, onClick, customTag }) => {
  const getIcon = () => {
    switch (iconType) {
      case 'order':
        if (isActive) {
          return getStaticImage('/icons/orange-brand/icon-order-up-primary.svg')
        } else {
          return getStaticImage('/icons/orange-brand/icon-order-down-grey.svg')
        }
      case 'unread':
        if (isActive) {
          return getStaticImage('/icons/orange-brand/icon-unread-primary.svg')
        } else {
          return getStaticImage('/icons/orange-brand/icon-unread-grey.svg')
        }
      case 'none-asign':
        if (isActive) {
          return getStaticImage('/icons/orange-brand/icon-none-asign-primary.svg')
        } else {
          return getStaticImage('/icons/orange-brand/icon-none-asign-grey.svg')
        }
      case 'one-one':
        if (isActive) {
          return getStaticImage('/icons/orange-brand/icon-1-1-primary.svg')
        } else {
          return getStaticImage('/icons/orange-brand/icon-1-1-grey.svg')
        }
      case 'outbound':
        if (isActive) {
          return getStaticImage('/icons/orange-brand/icon-outbound-primary.svg')
        } else {
          return getStaticImage('/icons/orange-brand/icon-outbound-grey.svg')
        }
      case 'filter':
        if (isActive) {
          return getStaticImage('/icons/orange-brand/icon-filter-active-primary.svg')
        } else {
          return getStaticImage('/icons/orange-brand/icon-filter-grey.svg')
        }
      case 'categories':
        if (isActive) {
          return getStaticImage('/icons/orange-brand/icon-category-label-on.svg')
        } else {
          return getStaticImage('/icons/orange-brand/icon-category-label-off.svg')
        }
      default:
        return ''
    }
  }

  if (!iconType) return null

  return (
    <IconSwitchUI
      id={uniqid()}
      height={height}
      tooltip={tooltip}
      onClick={onClick}
      getIcon={getIcon}
      CustomTag={customTag || 'button'}
    />
  )
}

export default IconSwitch
